import { Component } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MdbModalRef } from 'mdb-angular-ui-kit/modal';
import { HttpErrorsService } from '../../../../services/utils/http-errors.service';
import { finalize } from 'rxjs';
import { AddressFormComponent } from '../../../forms/address-form/address-form.component';
import { ModalComponent } from '../../../utils/modal/modal.component';
import { LocationModel } from "../../../../models/resources/location.model";
import {LocationService} from "../../../../services/resources/location.service";

@Component({
  selector: 'app-new-meeting-point-modal',
  imports: [
    AddressFormComponent,
    ModalComponent ],
  templateUrl: './new-meeting-point-modal.component.html',
  styleUrl: './new-meeting-point-modal.component.scss',
})
export class NewMeetingPointModalComponent {
  loading: boolean = false;
  formGroup: FormGroup | undefined;

  constructor(
    private modalRef: MdbModalRef<NewMeetingPointModalComponent>,
    private httpErrorService: HttpErrorsService,
    private locationService: LocationService
  ) {}

  submit() {
    this.formGroup!.markAllAsTouched();

    if (this.formGroup!.invalid)
      return;

    this.loading = true;

    let resource = {
      ...this.formGroup!.value,
      latitude: Number(
        this.formGroup!.value.latitude?.toString().replace(',', '.')
      ),
      longitude: Number(
        this.formGroup!.value.longitude?.toString().replace(',', '.')
      ),
    };

    this.locationService
    .create(resource)
    .pipe(finalize(() => (this.loading = false)))
    .subscribe({
next: (meetingPoint: LocationModel) => {
        this.modalRef.close(meetingPoint);
      },
      error: (e) => {
        this.httpErrorService.handleError(e);
      },
    });
  }
  getValueOf(controlName: string) {
    return this.formGroup?.get(controlName)?.value;
  }
}
